import { CONTENT } from "../../const/config";

export default function InstallGuideModal({ platform, onClose }) {
  const steps = CONTENT.installGuide?.[platform] ?? [];

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  if (steps.length === 0) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      onClick={handleBackdropClick}
    >
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 shrink-0">
          <div className="flex-1" />
          <h2 className="text-base font-bold text-gray-800 text-center">
            Hướng dẫn cài đặt {platform === "android" ? "Android" : "iOS"}
          </h2>
          <div className="flex-1 flex justify-end">
            <button
              onClick={onClose}
              className="p-1 rounded-full hover:bg-gray-100 transition-colors"
              aria-label="Đóng"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
        </div>

        {/* Scrollable body */}
        <div className="flex-1 overflow-y-auto px-5 py-4 space-y-5">
          {steps.map((step, idx) => (
            <div key={idx} className="text-center">
              <p className="text-lg font-bold text-blue-600 mb-2">
                Bước {idx + 1}
              </p>
              {step.image && (
                <img
                  src={step.image}
                  alt={`Bước ${idx + 1}`}
                  className="w-full object-contain px-20 rounded-lg border border-gray-100 bg-gray-50"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}